import { Injectable, inject } from '@angular/core';

import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { components } from 'src/assets/api/schema';

type ThemeDto = components['schemas']['ThemeDto'];
type ThemeListDto = components['schemas']['ThemeListDto'];
type UserThemeSettingsDto = components['schemas']['UserThemeSettingsDto'];

// Thin wrapper used by the core ThemeService + the user theme-selector. The admin
// Theme feature (create/edit/delete/restore) talks to the controller directly via
// ApiService; this service only covers app-boot + user-pref reads.
@Injectable({ providedIn: 'root' })
export class ThemeApiService {
    private __api = inject(ApiService);

    /** Backend default theme (anonymous — applied before login). */
    async Default_get(): Promise<ThemeDto | null> {
        const { data } = await this.__api.GET('/api/Theme/default', {});
        return data ?? null;
    }

    /** One selectable theme by guid (any logged-in user; null when deleted meanwhile). */
    async Details_get(guid: string): Promise<ThemeDto | null> {
        const { data } = await this.__api.GET('/api/Theme/selectable/details', {
            params: { query: { key: guid } },
        });
        return data ?? null;
    }

    /** All selectable (non-deleted) themes (any logged-in user). */
    async List_get(): Promise<ThemeListDto[]> {
        const { data } = await this.__api.GET('/api/Theme/selectable', {});
        return data ?? [];
    }

    /** Current user's persisted theme preference ({ selectedThemeGuid, colorMode } JSON). */
    async UserSettings_get(): Promise<UserThemeSettingsDto | null> {
        const { data } = await this.__api.GET('/api/Theme/usersettings', {});
        return data ?? null;
    }

    async UserSettings_put(json: string | null): Promise<void> {
        await this.__api.PUT('/api/Theme/usersettings', { body: { json } });
    }
}
